import { render, staticRenderFns } from "./AnimatedBid.vue?vue&type=template&id=fd1484de&"
import script from "./AnimatedBid.vue?vue&type=script&lang=js&"
export * from "./AnimatedBid.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedBid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports